import script from "./Decision.vue?vue&type=script&lang=ts&setup=true"
export * from "./Decision.vue?vue&type=script&lang=ts&setup=true"

import "./Decision.vue?vue&type=style&index=0&id=5315c3d0&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5315c3d0"]])

export default __exports__